/* eslint @typescript-eslint/no-var-requires: "off" */
const { Autoplay, Navigation } = require('swiper/modules');

export const swiperConfig = {
  modules: [Autoplay, Navigation],
  navigation: true,
  spaceBetween: 25,
  slidesPerView: 5,
  allowTouchMove: false,
  centeredSlides: true,
  loop: true,
  noSwipingClass: 'swiper-slide',
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 4000,
  breakpoints: {
    1024: {
      slidesPerView: 8,
      spaceBetween: 0,
    },
  },
};
